import { Customer } from '@model';
import { CustomerApprovalsActions, CustomerApprovalsActionTypes } from '../actions';

export interface State {
    distributionApprovalCustomers: Customer[];
    distributionApprovalCustomersLoading: boolean;
    distributionApprovalCustomersLoaded: boolean;
    distributionApprovalDelayedCustomerIds: string[];
    distributionApprovalDelayedCustomerIdsLoading: boolean;
    distributionApprovalDelayedCustomerIdsLoaded: boolean;
    delayDistributionApprovalProcessing: boolean;
    delayDistributionApprovalProcessed: boolean;
}

export const initialState: State = {
    distributionApprovalCustomers: [],
    distributionApprovalCustomersLoading: false,
    distributionApprovalCustomersLoaded: false,
    distributionApprovalDelayedCustomerIds: [],
    distributionApprovalDelayedCustomerIdsLoading: false,
    distributionApprovalDelayedCustomerIdsLoaded: false,
    delayDistributionApprovalProcessing: false,
    delayDistributionApprovalProcessed: false
};

export function reducer(state = initialState, action: CustomerApprovalsActions): State {
    switch(action.type) {
        case CustomerApprovalsActionTypes.LoadDistributionApprovalCustomers: {
            return {
                ...state,
                distributionApprovalCustomersLoading: true,
                distributionApprovalCustomersLoaded: false
            };
        }
        case CustomerApprovalsActionTypes.LoadDistributionApprovalCustomersSuccess: {
            return {
                ...state,
                distributionApprovalCustomers: action.payload,
                distributionApprovalCustomersLoading: false,
                distributionApprovalCustomersLoaded: true
            };
        }
        case CustomerApprovalsActionTypes.LoadDistributionApprovalCustomersFail: {
            return {
                ...state,
                distributionApprovalCustomersLoading: false,
                distributionApprovalCustomersLoaded: false
            };
        }
        case CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIds: {
            return {
                ...state,
                distributionApprovalDelayedCustomerIdsLoading: true,
                distributionApprovalDelayedCustomerIdsLoaded: false
            };
        }
        case CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIdsSuccess: {
            return {
                ...state,
                distributionApprovalDelayedCustomerIds: action.payload,
                distributionApprovalDelayedCustomerIdsLoading: false,
                distributionApprovalDelayedCustomerIdsLoaded: true
            };
        }
        case CustomerApprovalsActionTypes.LoadDelayedDistributionApprovalCustomerIdsFail: {
            return {
                ...state,
                distributionApprovalDelayedCustomerIds: [],
                distributionApprovalDelayedCustomerIdsLoading: false,
                distributionApprovalDelayedCustomerIdsLoaded: false
            };
        }
        case CustomerApprovalsActionTypes.DelayDistributionApprovalCustomers: {
            return {
                ...state,
                delayDistributionApprovalProcessing: true,
                delayDistributionApprovalProcessed: false
            };
        }
        case CustomerApprovalsActionTypes.DelayDistributionApprovalCustomersSuccess: {
            return {
                ...state,
                delayDistributionApprovalProcessing: false,
                delayDistributionApprovalProcessed: true
            };
        }
        case CustomerApprovalsActionTypes.DelayDistributionApprovalCustomersFail: {
            return {
                ...state,
                delayDistributionApprovalProcessing: false,
                delayDistributionApprovalProcessed: false
            };
        }
    }
    return state;
}

export const getDistributionApprovalCustomers = (state: State) => state.distributionApprovalCustomers;
export const getDistributionApprovalCustomersLoading = (state: State) => state.distributionApprovalCustomersLoading;
export const getDistributionApprovalCustomersLoaded = (state: State) => state.distributionApprovalCustomersLoaded;
export const getDelayDistributionApprovalProcessing = (state: State) => state.delayDistributionApprovalProcessing;
export const getDelayDistributionApprovalProcessed = (state: State) => state.delayDistributionApprovalProcessed;
export const getDistributionApprovalDelayedCustomerIds = (state: State) => state.distributionApprovalDelayedCustomerIds;
export const getDistributionApprovalDelayedCustomerIdsLoading = (state: State) => state.distributionApprovalDelayedCustomerIdsLoading;
export const getDistributionApprovalDelayedCustomerIdsLoaded = (state: State) => state.distributionApprovalDelayedCustomerIdsLoaded;